import styled from '@emotion/styled';
import React from 'react';
import Text03Img from 'ui/images/article/text_03.svg';

const DescriptionText = styled.p`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 0.96rem;
    line-height: 160%;
    letter-spacing: 0.8px;
    color: #1e4e66;
    margin: 0;
`;

const HighlightText = styled.span`
    font-weight: 600;
    color: #ee793f;
    background-color: #fffbc9;
`;

const ContentWrapper = styled.div`
    position: relative;
    width: 100%;
    margin-top: 40px;
    display: flex;
    justify-content: center;
`;

export const MaForBeginnerDerail_2_3: React.FC = () => {
    return (
        <>
            <DescriptionText>
                仲介会社には、全国展開している大手仲介会社、地域密着型の中小仲介会社、特定業界に強い専門仲介会社などがあります。それぞれの仲介会社ごとに、手数料体系、マッチングネットワークの広さ、照会可能候補先数の多寡、地元の買い手情報の多さ、特定分野でのノウハウ、マッチングのスピード感などが異なり、適切な仲介会社とM&Aを進めることでオーナーの意向を反映した丁寧なサポートが期待できます。
                <HighlightText>
                    自社の規模や業界特性に応じて、どのタイプが適しているかを見極めることが重要
                </HighlightText>
                です。
            </DescriptionText>
            <ContentWrapper>
                <img src={Text03Img} alt="M&Aの流れ" style={{ width: '100%', height: 'auto' }} />
            </ContentWrapper>
        </>
    );
};
